export default __webpack_public_path__ + "static/media/moralis.b6f8b3fd.gif";